import React from 'react';

export const AgencyAvatar = ({ agency, size = 'w-11 h-11' }) => {
  const logo = agency?.logo_url;
  const src = logo && (logo.startsWith('http') ? logo : `${process.env.REACT_APP_BACKEND_URL}${logo}`);
  return (
    <div className={`${size} rounded-xl bg-[#F5EFE1] border border-[#B85C38]/20 flex items-center justify-center overflow-hidden flex-shrink-0`}>
      {src ? <img src={src} alt={agency?.name} className="w-full h-full object-contain p-1" />
        : <span className="font-display font-bold text-[#B85C38]">{(agency?.name || '?').charAt(0)}</span>}
    </div>
  );
};

export const EmptyState = ({ icon: Icon, text, testid }) => (
  <div className="text-center py-12 bg-white rounded-2xl border border-dashed border-[#B85C38]/25" data-testid={testid}>
    <Icon className="w-10 h-10 mx-auto text-[#B85C38]/40 mb-3" strokeWidth={1.4} />
    <p className="text-sm text-gray-500">{text}</p>
  </div>
);

export const fmtMoney = (n) => `${Number(n || 0).toLocaleString('fr-FR')} FCFA`;

export const inputCls = 'mt-1 w-full rounded-xl border border-gray-200 px-3 py-2 text-sm bg-white focus:ring-2 focus:ring-[#B85C38] outline-none';
